/**
 * Site header — scroll state + smooth scroll with header offset.
 *
 * initHeaderScroll : adds/removes `.is-scrolled` on `#site-header` as the
 *                    user scrolls past 10 px (used for CSS shadow transitions).
 *
 * initSmoothScroll : intercepts all `<a href="#…">` clicks and scrolls
 *                    smoothly to the target while accounting for the sticky
 *                    header height.
 */

/**
 * Toggle `.is-scrolled` class on `#site-header` based on scroll position.
 */
export function initHeaderScroll() {
  const header = document.getElementById('site-header');
  if (!header) return;

  function updateScrollState() {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }

  updateScrollState();
  window.addEventListener('scroll', updateScrollState, { passive: true });
}

/**
 * Smooth-scroll anchor links, offsetting by the sticky header height + 16 px gap.
 */
export function initSmoothScroll() {
  const header = document.getElementById('site-header');
  const offset = (header ? header.getBoundingClientRect().height : 64) + 16;

  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;

    const id = anchor.getAttribute('href')?.slice(1);
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
    history.pushState(null, '', `#${id}`);
  });
}
